import type { FormatBundle } from '../format/bundle';
import { useLocalizationContext } from './useLocalizationContext';

/**
 * The formatters, bound to the signed-in user's preferences.
 *
 * The main entry point for feature code, and the reason there is no branch on locale or unit
 * anywhere in a feature: a caller says what the backend sent and the bundle knows the rest.
 *
 * The returned object keeps the same identity for as long as the preferences hold, which is
 * normally the whole session, so it is safe in a dependency array and will not invalidate a
 * `useMemo` or break a `React.memo` boundary.
 *
 * @returns The bundle. See {@link FormatBundle}.
 * @throws If no `<LocalizationProvider>` is mounted above the caller.
 */
export const useFormat = (): FormatBundle => useLocalizationContext().format;
